import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,
  state: {
    isMobile: false
  },
  mutations: {
    updateField
  },
  getters: {
    getField,
    isMobile: (state) => state.isMobile
  }
}